module.exports = __webpack_public_path__ + "img/indo-win-b.7abdd623.png";